export const getProductStock = (product = {}) => {
  const detail = product?.dtl?.[0] || {};
  return Number(product?.stock ?? detail?.stock ?? 0);
};

export const isOutOfStock = (product = {}) => getProductStock(product) <= 0;
